import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import env from '../ENV';
import {getAuditTrails,InsertAuditTrail,GetAuditTrailsByRolePOAndPOLineItemId} from '../store/actions/auditTrailActions'
import swal from '@sweetalert/with-react';
import {connect} from 'react-redux'
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import DropdownFlat from '../Components/DropdownFlat'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;


function formatDate(date) {
    var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    
    if (month.length < 2) 
    month = '0' + month;
    if (day.length < 2) 
    day = '0' + day;
    
    return [day, month, year].join('-');
  }
  
 
  class AuditTrailHome extends React.Component {

    constructor(props) {
        super(props);
        this.state={
         
        supplierName: "ABC Tech Inc.",
        select: true,
        open: false,
        selectAll: false,
        checked: [],
        opacity:"",
        modal: false,
        
        multiCollapseIndex:"",      
        array1 :[

          {  value: 1,  PoNo: "4700026643", PoItem: "40" , createdOn: "12-06-2020", PoAmount: "2426309", status: "Ready To Dispatch(DAP)", WBSNo:"AXX011", Location:"Mumbai", Comments:"" },
          {  value: 2,  PoNo: "4700029943", PoItem: "20" , createdOn: "10-06-2019", PoAmount: "1250789", status: "Documents Requested", WBSNo:"AXX011", Location:"Bangalore", Comments:"" },
          {  value: 3,  PoNo: "4700023443", PoItem: "40" , createdOn: "01-05-2020", PoAmount: "456300", status: "Documents Requested", WBSNo:"AXX011", Location:"Chennai", Comments:"" },
          {  value: 4,  PoNo: "4700026243", PoItem: "10" , createdOn: "05-06-2019", PoAmount: "156801", status: "Inspection Requested", WBSNo:"AXX011", Location:"Mumbai", Comments:"" },
     ],
         }
      
      this.togglebutton = this.togglebutton.bind(this); 
      this.modal= this.modal.bind(this); 
      this.modalSubmit= this.modalSubmit.bind(this);
     }
    action1() {
        this.setState({ action1: false });
    }
    togglebutton=(Index)=> {  
        // const { open } = this.state;  
        // this.setState({  
        //     open: !open,  
        // }); 
        var multiCollapseIndex = this.state.multiCollapseIndex
    
        if(multiCollapseIndex!=Index || multiCollapseIndex==''){
          this.setState({multiCollapseIndex:Index})
      }  
    } 

    handleSelect=(e)=>{
         this.setState({
         selectedpaymentmethod : e.target.value
        })

    }  
    
    async modalSubmit(){
    
      this.modal()
     
  }

    modal() {
      this.setState({ modal: !this.state.modal });
      if (this.state.modal == true) {
        this.setState({ opacity: "" })
      }
      else {
        this.setState({ opacity: "0.2" })
      }
    }

    componentDidMount(){ 
      this.props.getAuditTrails()
      // this.props.GetAuditTrailsByRolePOAndPOLineItemId({
      //     "PurchaseOrderId":0
      // })
      // this.props.InsertAuditTrail({
      //   "PurchaseOrderId":0,
      //   "PurchaseOrderLineId":8,
      //    "UserId":0,
      //    "RoleId":0
      //  })
     }  

    render()
    {

      console.log(this.props.auditpouser.auditPouser,"@@@@")
        return(
            <div className="Container-fluid pageheight" >             
               <div className="Container-fluid p-4" >

               <Modal isOpen={this.state.modal} >
                <div className={"modal-bg" + (this.state.modal === 'false'  ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header modalheaderWide ">
                            <div><h4 >Document Details</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>

                    <div >
                        <ModalBody Style="modal-body modalbodysWideBudget ">
                            <div className="col-md-12 pt-2">
                                <div className="row ">
                                    <div className="col-md-4 pt-2 " ><b>Document Name :</b></div> 
                                    <div className="col-md-6 pt-2">
                                      Drawing
                                    </div>    
                                </div>  
                                <div className="row">
                                    <div className="col-md-4 pt-2 " ><b>Document Status :</b></div> 
                                    <div className="col-md-6 pt-2">
                                      Awaiting Approval From/All Approved
                                    </div>    
                                </div> 

                            <div className="row  mt-4 align">
                              <div className="col-md-10 ">
                              <table border = "1" className="table5 "  >
                               <tr className="headerbar ">                           
                                <td>Acted Department</td>
                                <td>Acted Person</td>
                                <td>Acted On</td>
                                <td>Action Status</td>
                              </tr>
                              <tr className="rows headeralign">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr className="rows headeralign">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </table>
                            </div>
                              </div>
                            </div>
                        </ModalBody>
                    </div>
                    <div>    
                        <ModalFooter FooterStyle="modal-footer modalheaderWide">
                            <div>
                                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modalSubmit} type="submit">OK</button>
                                <button type="button" className="btn2 btn-sms1 mt-2 float-right" onClick={this.modal}> Cancel </button>
                            </div>
                        </ModalFooter>
                    </div>
                </div>
            </Modal>


               <div className="row pr-4" >
               <div className="col-md-8 ">
               {/* <button className="btn2 btn-sms1 mt-2 float-right"  type="submit" onClick={this.modal}> Approve </button> */}
               </div> 
                    
              <div className="col xs={last} pt-2" style={{paddingRight: 30}}>
                 <SearchBar placeholder="Search"  label="Search"  btnName=""  />
              </div> 
            </div>
<br />
<br />
<br />
                <div className="row-md-8 pr-4">
                    <div className="col ">
                        <div className="row  headerbar ">
                            
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO ID</div>
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Line Item</div>                           
                            <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">WBS Code</div>
                            <div className="col-md-4 pt-2 pb-2 borderheaderbar d-none d-sm-block ">Vendor</div>
                            <div className="col pt-2 pb-2 borderheaderbar d-none d-sm-block">Action</div>

                        </div>

                        {this.props.auditpouser.auditPouser && this.props.auditpouser.auditPouser.recordset && this.props.auditpouser.auditPouser.recordset.length > 0 && this.props.auditpouser.auditPouser.recordset.map((element, Index) =>

                        <div className={Index%2==0? 'row border ':'row  background '} 
                            onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                           
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.POLineItemSAPCode}</div>
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{element.WBSCode}</div>
                           <div className="col-md-4 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{element.UserName}</div>                          
                           <div className="col-md-2 pt-2 pb-2 borderheaderbar text-center d-none d-sm-block ">            
                                <Link to= {{ pathname: '/auditTrailPage',state : {POSAPId: element.POSAPId} }}><FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" /></Link>
                           </div>
                             
                         {/* <div className={Index==this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse` }> 
                          <form>
                                             {/* <div></div> */}
                                            {/* <div className="row"> */} 
                                                {/* <div className="col-md-2">
                                                  <b>WBS No: </b>
                                                </div>
                                                <div className="col">
                                                {element.WBSNo}
                                                </div>                                                */}
                                                {/* <div className="col-md-2">
                                                  <b>Location:</b>
                                                </div>
                                                <div className="col">
                                                {element.Location}
                                                </div>
                                            </div>
                                            <br></br>
                                            <div className="row">
                                                <div className="col-md-2">
                                                  <b>Comments:</b>
                                                </div>
                                                <div className="col">
                                                {element.Comments}
                                                </div>
                                            </div> 
                                            <br/> 
                                 {/* </form> 
                             </div> */}
                          </div>
                         )}          
                    </div>
                </div>
            </div>
     </div>
            
        )
    }
}
const mapStateToProps  = (state) => ({auditpouser:state.auditTrailReducer,getaudit:state.auditTrailReducer, auditinsert:state.auditTrailReducer})
export default connect(mapStateToProps, {getAuditTrails,InsertAuditTrail,GetAuditTrailsByRolePOAndPOLineItemId}) (AuditTrailHome);